import { Form, Input } from 'antd';
import React, { useEffect } from 'react';
import TableCustomerEmail from './TableCustomerEmail';

const Customer = ({ dataSource }) => {
  const [form] = Form.useForm();

  // console.log('Customer', dataSource);
  

  const CustomerEmail = dataSource?.CustomerEmail || [];

  useEffect(() => {
    if (form && dataSource) {
      form.setFieldsValue(dataSource.Customer);
    }
  }, [dataSource, form]);

  const onsubmit = (values) => {
    console.log("Submit", values);
  };

  return (
    <>
      <Form
        name="filterForm"
        layout="vertical"
        onFinish={onsubmit}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          label="Customer Name"
          name="CustomerName"
        >
          <Input placeholder="Customer Name" disabled />
        </Form.Item>

        <Form.Item
          label="Mobile Phone"
          name="MobilePhone"
        >
          <Input placeholder="Mobile Phone" disabled />
        </Form.Item>

        <Form.Item
          label="Email Contact"
          name="EmailContact"
        >
          <Input placeholder="Email Contact" disabled />
        </Form.Item>

        <Form.Item
          label="Address"
          name="Address"
        >
          <Input placeholder="Address" disabled />
        </Form.Item>

        <Form.Item
          label="Fax"
          name="Fax"
        >
          <Input placeholder="Fax" disabled />
        </Form.Item>
      </Form>

      <TableCustomerEmail dataSource={CustomerEmail} />

    </>
  );
};

export default Customer;
